import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {StringUtils} from "../services/stringutils";

@Pipe({
  name: 'unescapeCache',
})
export class UnescapeCachePipe implements PipeTransform {

  constructor(protected stringUtils: StringUtils) {

  }

  public transform(value: string): string {
    return this.stringUtils.unescapeTransferStateCacheData(value);
  }

}

@NgModule({
  declarations: [UnescapeCachePipe],
  exports: [UnescapeCachePipe]
})
export class UnescapeCachePipeModule {}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/unescape-cache-pipe.ts